import React, { PropsWithChildren } from 'react'
import { ProjectListingBannerProps } from '../../slices/ProjectListingBanner'
import ContactHeader, { ContactHeaderProps } from '../Contact/ContactHeader'
import { Grid } from '../Grid'
import ProjectListingBanner from '../ProjectListingBanner'
import HeaderOptionOne, { HeaderOptionOneProps } from './HeaderOptionOne'
import HeaderOptionThree, { HeaderOptionThreeProps } from './HeaderOptionThree'
import HeaderOptionTwo, { HeaderOptionTwoProps } from './HeaderOptionTwo'
import classes from './headerDescription.module.scss'


type HeaderDescriptionProps = HeaderOptionOneProps & HeaderOptionTwoProps & HeaderOptionThreeProps & ProjectListingBannerProps & ContactHeaderProps &{
}

export const HeaderDescription:React.FC<PropsWithChildren<{headerData: HeaderDescriptionProps}>> = ({ headerData })=> {
  const renderHeaderDescription = ()=> {
    switch (headerData.component) {
    case 'header_two_col':
      return (
        <HeaderOptionOne
          title={headerData.title}
          description={headerData.description}
          component={headerData.component}
          withDescription={headerData.withDescription} />
      )
    case 'header_three_row':
      return (
        <HeaderOptionTwo
          sub_title={headerData.sub_title}
          title={headerData.title}
          description={headerData.description}
          component={headerData.component} />
      )

    case 'header_one_col':
      return (
        <HeaderOptionThree
          title={headerData.title}
          component={headerData.component} />
      )

    case 'project_listing_banner': {
      return (
        <>
          {
            headerData.banner.length > 0 ? (
              <ProjectListingBanner headerBanner={headerData} />
            ) : null
          }
        </>
      )
    }

    case 'header_contact': {
      return (
        <>
          {
            (
              <ContactHeader header_left={headerData.header_left} component={headerData.component} header_right={headerData.header_right} />
            )
          }
        </>
      )
    }
    }
  }

  return(
    <Grid container>
      <div className={classes.headerContainer}>
        {renderHeaderDescription()}
      </div>
    </Grid>
  )
}

export default HeaderDescription
